---
pageId: faq
title: Frequently asked questions
description: Short answers about plans and limits, trackers, metrics and your data in Samlla.
category: faq
order: 1
lang: en
slug: faq
updated: 2026-08-06
---

Short answers to the questions we hear most. Every answer links to a page that goes deeper.

## Plans and limits

### What does the Free plan include?

Five trackers with up to 3 metrics each, 2 categories, unlimited new entries and 90 days of visible history. Every Stats view, including Year, is available. Earlier days in the yearly layout are masked and stay safely stored.

### What does Pro add?

Pro removes the plan limits on trackers, metrics and categories and unlocks full history. The yearly view itself is not paywalled; Pro reveals the history that Free keeps masked.

### Do templates fit the Free plan?

Yes — every one of the 30 [templates](/wiki/features/templates) keeps to at most 3 metrics on purpose, so any of them works on Free.

## Trackers and entries

### Can I switch a tracker between journal mode and metrics mode?

No. The mode is chosen when you create the tracker and cannot be changed later. If you need the other mode, create a new tracker — [What is a Tracker](/wiki/concepts/tracker) explains both modes.

### What happens when I delete a tracker?

Deleting moves the tracker to the trash, with permanent deletion scheduled 30 days later. Until then you can restore it from Settings. Archiving is the gentler option: the tracker disappears from the main list but keeps all data indefinitely.

### Can I log an entry for a past day?

Yes. The quick-add drawer has one-tap offsets (-15m, -1h, -1d) and a full date picker, and a tracker's schedule never blocks manual entries from other days.

### Can I undo deleting an entry?

No — deleting an entry asks for confirmation precisely because it cannot be undone.

## Your data

### What happens after a downgrade to Free?

Nothing is deleted. Existing trackers, metrics, categories and entries stay stored. Free shows the last 90 days and blocks only creating objects above its plan limits. Returning to Pro reveals the complete history again.
